import React from 'react'
import PollsSection from 'src/sections/PollsSection'
import { Poll } from 'src/api/types/polls'
import { GameSounds } from 'src/ui/sound/types'

export type DashboardPollsTabViewProps = {
  selectedListTab: string
  userId?: number
  pollRefreshKey: number
  onPollSelect: (poll: Poll) => void
  onPollVote: (poll: Poll, hasVoted: boolean) => void
  onPollPlay: (poll: Poll) => void
  sounds?: GameSounds
}

const DashboardPollsTabView: React.FC<DashboardPollsTabViewProps> = ({
  selectedListTab,
  userId,
  pollRefreshKey,
  onPollSelect,
  onPollVote,
  onPollPlay,
  sounds,
}) => {
  if (selectedListTab !== 'polls') return null

  return (
    <PollsSection
      userId={userId}
      onPollSelect={onPollSelect}
      onPollVote={onPollVote}
      onPollPlay={onPollPlay}
      refreshKey={pollRefreshKey}
      sounds={sounds}
    />
  )
}

export default DashboardPollsTabView
